/*
 * Cadwork webgl Engine
 * http://www.lexoview.com
 *
 * Copyright (C) 2015 Cadwork Informatik AG, Basel, Switzerland
 * Dual licensed under the MIT and GPL
 *
 * @author Jaroslav Přibyl (pribyl@cadwork.cz)
 *
 */

import Description from "App/model/description";

export default
class CameraAnimation {
    private _parsedID: number = -1;
    private _parsedUrl: string = "";
    private _parsedName: string = "";

    public parse(aAnimationJSON: any, aModelDescription: Description) {
        if (!aAnimationJSON.hasOwnProperty("url")) {
            return false;
        }

        this._parsedID = aAnimationJSON.ID;
        this._parsedUrl = aAnimationJSON.url;
        this._parsedName = aAnimationJSON.name;

        if (this._parsedUrl.indexOf("http") === -1) {
            this._parsedUrl = aModelDescription.getRenderModel().getBaseUrl() + this._parsedUrl;
        }

        return true;
    }

    public getID(): number {
        return this._parsedID;
    }

    public getUrl(): string {
        return this._parsedUrl;
    }

    public getName(): string {
        return this._parsedName;
    }

    public getJSONRepresentation(): any {
        return {
            ID: this._parsedID,
            url: this._parsedUrl,
            name: this._parsedName
        }
    }
}